<h1 mat-dialog-title class="text-3xl">{{'settlementaccount.header_topup' | translate}}</h1>
<div mat-dialog-content class="font-medium">
  <p> {{'settlementaccount.description_topup' | translate}}
  </p>

</div>

<mat-form-field class="input_w-full" appearance="outline">
  <mat-label>{{'settlementaccount.buffer_amount' | translate}}</mat-label>
  <input matInput type="number">
</mat-form-field>

<div mat-dialog-actions>
  <button class="button-regular" type="button" mat-dialog-close>{{'settlementaccount.proceed_payment' | translate}}</button>
</div>
